import React, { FC, ReactElement, useContext, useEffect, useMemo } from 'react'
import FormRow from '../../Common/Components/FormRow'
import { LanguageContext } from '../../Common/Contexts'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import {
    COMMS_ENABLED_FIELD_NAME,
    LAST_SYNC_FIELD_NAME,
    SYNC_NOW_FIELD_NAME,
    TYPE_FIELD_NAME
} from '../Constants/FieldNames'
import { TelSysConfiguration } from '../../../../i18n'
import { useFormContext, UseFormMethods } from '../../../Vendor/react-hook-form/dist/index.ie11'
import { TelSysForm } from '../Types/Types'
import { TelSysTypes } from '../Constants/Constants'
import { StatusOutput } from '../../Common/Components/StatusOutput/StatusOutput'
import { RouterCheckbox } from '../../../ReactRouting/Components/Atoms/Inputs/RouterCheckbox'
import { OutlinedTextInput } from '../../../ReactRouting/Components/Atoms/Inputs/OutlinedTextInput'

type Props = {
    viewOnly?: boolean
    syncStatus?: Nullable<string>
}

export const SyncTab: FC<Props> = ({ viewOnly, syncStatus }: Props): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler

    const { watch, setValue }: UseFormMethods<TelSysForm> = useFormContext()

    const syncNowValue: boolean = watch(SYNC_NOW_FIELD_NAME, false)
    const telSysTypeValue: TelSysTypes = watch(TYPE_FIELD_NAME)
    const commsEnabledValue: Nullable<boolean> = watch(COMMS_ENABLED_FIELD_NAME, false)

    const isTelSysTypePanasonic: boolean = useMemo(
        (): boolean => telSysTypeValue === TelSysTypes.PANASONIC_TDA_NCP,
        [telSysTypeValue]
    )

    useEffect((): void => {
        if (!commsEnabledValue) {
            setValue(SYNC_NOW_FIELD_NAME, false)
        }
    }, [commsEnabledValue])

    return isTelSysTypePanasonic ? (
        <div className='sync-tab tab-area'>
            <FormRow>
                <RouterCheckbox
                    name={SYNC_NOW_FIELD_NAME}
                    labelLeft={language.get(TelSysConfiguration.TelSysConfiguration_Field_SyncNow_Label)}
                    disabled={viewOnly || !commsEnabledValue}
                />
                {syncNowValue ? (
                    <>
                        <br />
                        <div className='warning-info'>
                            {language.get(TelSysConfiguration.TelSysConfiguration_Field_SyncNow_Warning)}
                        </div>
                    </>
                ) : (
                    <> </>
                )}
            </FormRow>
            <FormRow>
                <OutlinedTextInput
                    inputName={LAST_SYNC_FIELD_NAME}
                    labelLeft={language.get(TelSysConfiguration.TelSysConfiguration_Field_SyncLastStarted_Label)}
                    placeholder={language.get(
                        TelSysConfiguration.TelSysConfiguration_Field_SyncLastStarted_Placeholder
                    )}
                    disabled
                />
            </FormRow>
            <StatusOutput
                statuses={[
                    syncStatus ?? language.get(TelSysConfiguration.TelSysConfiguration_Field_SyncStatus_Placeholder)
                ]}
            />
        </div>
    ) : (
        <> </>
    )
}
